module.exports = "/static/assets/070cb59572afba5416e21e732d098557.png";